import React from 'react';
import styles from '../style/HeaderLogo.module.scss';

import logo from '../../../../assets/image/DHI_Logo_White.png';

import { useNavigate } from 'react-router';
export default function HeaderLogo({
  onClick,
}: {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}) {
  const navigate = useNavigate();

  return (
    <div
      onClick={onClick}
      role="logo"
      aria-label="site logo"
      className={styles.logo}
      id='Header-Logo_Button'
    >
      <img
        onClick={() => {
          navigate('/');
        }}
        style={{ cursor: 'pointer' }}
        src={logo}
        alt={'dhi logo'}
      />
      <div className={`${styles.logoTextContainer}`}>
        <h1>Metocean Data Portal</h1>
      </div>
    </div>
  );
}
